/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unregisterAlias} from '../api'

export const useMutationUnregisterAlias = createReactQueryMutationHook('unregisterAlias', unregisterAlias)
